import { IMPORT_MODE } from "@/constant/Imports/importMode";

const BasicImportInitialValues = (defaultMode = IMPORT_MODE.ADD) => ({
  data_file: null,
  mode: defaultMode,
});

export default BasicImportInitialValues;
